'use strict';

var Sugar = require('sugar-core'),
    PrimitiveRangeConstructor = require('../range/var/PrimitiveRangeConstructor');

Sugar.String.defineStatic({

  'range': PrimitiveRangeConstructor

});

module.exports = Sugar.String.range;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/range.js
// module id = 1129
// module chunks = 1